import React, { useRef } from 'react';
// import { useParams } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Button from '../../components/elements/button';
import { Download } from '../../assets/icons';
import logo from '../../assets/icons/logo.svg';
import '../../assets/css/pages/certificate.css';

const Certificate = () => {
    // const { courseId } = useParams();
    const certificateRef = useRef();

    // Mock certificate data
    const certificateData = {
        studentName: "John Doe",
        courseName: "Advanced Aquaculture Management",
        completionDate: new Date().toLocaleDateString(),
        courseHours: "40",
        certificateId: "EAQUA-2024-001",
        instructor: "Dr. Sarah Johnson"
    };

    const downloadCertificate = async () => {
        const certificate = certificateRef.current;
        const canvas = await html2canvas(certificate);
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('landscape');
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`${certificateData.courseName}_Certificate.pdf`);
    };

    return (
        <div className="certificate-page">
            <div className="certificate-actions">
                <Button
                    text="Download Certificate"
                    icon={<img src={Download} alt="" />}
                    variant="primary"
                    onClick={downloadCertificate}
                />
            </div>

            <div className="certificate-container" ref={certificateRef}>
                <div className="certificate">
                    <div className="certificate-header">
                        <img src={logo} alt="E-AquaHealth Logo" className="logo" />
                        <h1>Certificate of Completion</h1>
                    </div>

                    <div className="certificate-content">
                        <p className="declaration">This is to certify that</p>
                        <h2 className="student-name">{certificateData.studentName}</h2>
                        <p className="completion-text">
                            has successfully completed the course
                        </p>
                        <h3 className="course-name">{certificateData.courseName}</h3>
                        <p className="course-details">
                            A {certificateData.courseHours}-hour comprehensive course in aquaculture
                        </p>
                    </div>

                    <div className="certificate-footer">
                        <div className="dates">
                            <p>Completed on {certificateData.completionDate}</p>
                            <p>Certificate ID: {certificateData.certificateId}</p>
                        </div>
                        
                        <div className="signatures">
                            <div className="signature">
                                <img src="/signature.png" alt="Instructor Signature" />
                                <p>{certificateData.instructor}</p>
                                <p className="title">Course Instructor</p>
                            </div>
                            <div className="signature">
                                <img src="/director-signature.png" alt="Director Signature" />
                                <p>Dr. James Wilson</p>
                                <p className="title">Program Director</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Certificate;